import cx from 'classnames';
import { forwardRef, useMemo } from 'react';

import { IButtonIconProps } from './types';

const ButtonIcon = forwardRef<HTMLButtonElement, IButtonIconProps>(
  ({ icon, onClick, className, type = 'primary', disabled = false }: IButtonIconProps, ref) => {
    const buttonClassName = useMemo(() => {
      return cx(className, 'flex items-center justify-center h-[32px] w-[32px] rounded-full', {
        'bg-background-button-primary text-text-primaryInverse enabled:hover:bg-background-button-primaryHover':
          type === 'primary',
        'bg-global-transparent-black-10 text-textPrimary border border-border-strong enabled:hover:bg-background-button-secondaryHover':
          type === 'secondary',
        'bg-global-transparent-black-10 text-textPrimary border border-border-light enabled:hover:bg-background-button-tertiaryHover':
          type === 'tertiary',
        'text-text-link enabled:hover:bg-background-button-plainHover': type === 'plain',
        'opacity-50': disabled,
      });
    }, [className, type, disabled]);

    return (
      <button ref={ref} className={buttonClassName} onClick={onClick} disabled={disabled}>
        {icon}
      </button>
    );
  },
);
ButtonIcon.displayName = 'ButtonIcon';

export { ButtonIcon };
